export function validateRequired(value: any): boolean {
    return !!value;
}

/**
 * Returns a string format of the regex without the forward slash in the beginning and in the end.
 */
export const getRegexInString = (regex: RegExp): string => {
    return regex.toString().slice(1, -1);
};

export const emailRegex: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function validateEmail(email: string): boolean {
    return !email || emailRegex.test(email.toLowerCase());
}

export function validatePhone(phone: string): boolean {
    const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
    return !phone || re.test(phone);
}

/**
 * @param phone Given a string phone number from user input (especially StyledMaskedInputBox)
 * return either a string of digits only (no punctuation) or undefined (never empty string)
 * This is designed to conform to https://schemas.dealerinspire.com/online-shopper/phone.json#
 */
export function cleanPhone(phone: string): string | undefined {
    return phone.replace(/[^0-9]/g, "") || undefined;
}

export function validateZip(zip: string, isUS: boolean): boolean {
    const re = isUS ? /^[0-9]{5}$/ : /^[a-z][0-9][a-z] [0-9][a-z][0-9]$/i;
    return !zip || re.test(zip);
}

export function validateSSN(ssn: string, isUS: boolean): boolean {
    const re = isUS ? /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/ : /^[0-9]{3}-?[0-9]{3}-?[0-9]{3}$/;
    return !ssn || re.test(ssn);
}

export function validateCurrencyAmount(amount: string): boolean {
    const num = parseFloat(amount);
    return !amount || (!Number.isNaN(num) && num >= 0);
}
